import { z } from "zod";

/**
 * `Progress`（ドメイン層）の永続化形状のZodスキーマ。**ドメイン層はzodに依存できない**ため、
 * スキーマはインフラ層に置き、検証を通ったものだけをリポジトリ実装でドメインの値オブジェクト
 * （`ReadonlySet`）へ変換する（腐敗防止層。ADR-006）。
 *
 * `.strict()` により未知のフィールドを拒否する（`spec/design.md` の読み込みフローチャート）。
 */

/** 保存データ本体のスキーマ。`schemaVersion` は現行版（1）のみを許容する。 */
export const persistedProgressSchema = z
  .object({
    schemaVersion: z.literal(1),
    clearedDrills: z.array(z.string()),
    stamps: z.array(z.string()),
    updatedAt: z.string(),
  })
  .strict();

export type PersistedProgress = z.infer<typeof persistedProgressSchema>;

/**
 * 本体スキーマの検証前に、`schemaVersion` だけを緩く読み取るためのスキーマ。
 * 「保存データのバージョンが未来かどうか」を判定するための最初の関門であり、
 * それ以外のフィールドの形は問わない（`.passthrough()`）。
 */
export const schemaVersionProbeSchema = z
  .object({
    schemaVersion: z.number(),
  })
  .passthrough();
